<div [formGroup]="formGroup" class="client-intake-address">
  <div>
    <common-form-control
      controlName="streetAddress"
      [label]="labels.line1 | labelText"
      [isOptional]="!hideOptionalLabel && !_isRequired"
    >
      <input
        type="text"
        formControlName="streetAddress"
        [attr.data-cy]="dataCyPrefix + '-Address line 1'"
        autocomplete="street-address"
      />
    </common-form-control>
  </div>
  <div>
    <common-form-control [label]="labels.line2 | labelText" controlName="suiteNumber" [isOptional]="!hideOptionalLabel">
      <input
        type="text"
        formControlName="suiteNumber"
        [attr.data-cy]="dataCyPrefix + '-Address line 2'"
        autocomplete="address-line2"
      />
    </common-form-control>
  </div>

  <div>
    <common-form-control
      class="city"
      controlName="city"
      [label]="labels.city | labelText"
      [isOptional]="!hideOptionalLabel && !_isRequired"
    >
      <input type="text" formControlName="city" [attr.data-cy]="dataCyPrefix + '-city'" />
    </common-form-control>
  </div>
  <div class="province">
    <common-form-control
      class="province"
      controlName="provState"
      [label]="labels.province | labelText"
      [isOptional]="!hideOptionalLabel && !_isRequired"
    >
      <input type="text" formControlName="provState" [attr.data-cy]="dataCyPrefix + '-province'" />
    </common-form-control>
  </div>

  <div class="postal-code">
    <common-form-control
      controlName="postalZip"
      [label]="labels.postalCode | labelText"
      [isOptional]="!hideOptionalLabel && !_isRequired"
    >
      <input [attr.data-cy]="dataCyPrefix + '-postalCode'" type="text" formControlName="postalZip" />
    </common-form-control>
  </div>

  <div class="country">
    <common-form-control
      controlName="country"
      [label]="labels.country | labelText"
      [isOptional]="!hideOptionalLabel && !_isRequired"
    >
      <mat-select
        formControlName="country"
        [attr.data-cy]="dataCyPrefix + '-country'"
        role="combobox"
        aria-label="country"
        size="10"
      >
        <mat-option *ngFor="let country of countries" [value]="country.code">{{ country.displayName }}</mat-option>
      </mat-select>
    </common-form-control>
  </div>
</div>
